import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import Selectors from "../../Selectors";
import ActionCreator from "../../ActionCreator";
import AppConfig from "../../Config/HeCafeConfig";
import Login from "../Login";
import NavIconButton from "../NavIconButton";
import * as Icon from "../Icon";
import * as Widget from "../Widget";
import Link from "../Link";

const {
  background,
  altBackground,
  textColor,
  textShadow,
  breakpoint
} = AppConfig["Components/Navbar"];
const height = AppConfig.global.navbarHeight;

const navItems = [
  { children: "好咖啡豆", url: "/products" },
  { children: "精選店家", url: "/stores" },
  { children: "尋香氣", url: "/aroma" },
  { children: "找焙度", url: "/roast" },
  { children: "搜產地", url: "/map" },
  { children: "好咖文選", url: "/blogs" },
  { children: "profile", url: "/me" },
  { children: "cart", url: "/cart" }
];

const ScreenSizeBoundry = 800;

class Navbar extends React.Component {
  state = {
    openMenu: false,
    openLoginDialog: false,
    path: "/"
  };

  render() {
    let { isNavbarTransparent, passBreakpoint } = this.props;

    return (
      <Style.Wrapper
        isNavbarTransparent={isNavbarTransparent}
        passBreakpoint={passBreakpoint}
      >
        <Style.Content>
          <Link to="/" className="site-logo">
            <img src="/images/logo.png" style={{ width: 62, height: 43 }} />
          </Link>

          {this._smallScreenNavBar()}
          {this._largeScreenNavBar()}
        </Style.Content>
      </Style.Wrapper>
    );
  }

  _smallScreenNavBar() {
    const toggleMenuState = () =>
      this.setState({ openMenu: !this.state.openMenu });
    let { isNavbarTransparent } = this.props;
    let { openLoginDialog, path } = this.state;

    return (
      <Style.SmallScreenWrapper Breakpoint={ScreenSizeBoundry}>
        <Widget.IconButton onClick={toggleMenuState}>
          <Icon.Apps color="black" />
        </Widget.IconButton>

        <Style.SmallScreenMenu
          open={this.state.openMenu}
          onClick={toggleMenuState}
        >
          <div className="container">
            {[
              { children: <Icon.Home color="black" size={26} />, url: "/" },
              ...navItems
            ].map((result, idx) => {
              if (idx === 0) {
                return (
                  <Link to={result.url} key={idx} className="nav-item">
                    {result.children}
                  </Link>
                );
              }

              if (idx >= 1 && idx <= 6) {
                return (
                  <Link to={result.url} key={idx} className="nav-item">
                    {result.children}
                  </Link>
                );
              }

              return (
                <div
                  key={idx}
                  className="nav-item"
                  onClick={() => this._needToLogin(result)}
                >
                  <NavIconButton img={result.children} />
                </div>
              );
            })}
            {openLoginDialog && (
              <Login.Dialog
                resultPath={path}
                onClose={() => this.setState({ openLoginDialog: false })}
              />
            )}
          </div>
        </Style.SmallScreenMenu>
      </Style.SmallScreenWrapper>
    );
  }

  _largeScreenNavBar() {
    let { isNavbarTransparent } = this.props;
    let { openLoginDialog, path } = this.state;

    return (
      <Style.LargeScreenWrapper
        isNavbarTransparent={isNavbarTransparent}
        Breakpoint={ScreenSizeBoundry}
      >
        <div className="left">
          {navItems
            .filter((result, idx) => idx < 6)
            .map((result, idx) => (
              <Link
                to={result.url}
                key={idx}
                className={`nav-item ${
                  this._isActiveRoute(result.url) ? "active" : ""
                }`}
              >
                <span>{result.children}</span>
              </Link>
            ))}
        </div>
        <div className="right">
          {navItems
            .filter((_, idx) => idx > 5)
            .map((result, idx) => (
              <div
                onClick={() => this._needToLogin(result)}
                key={idx}
                className="nav-item"
              >
                <NavIconButton
                  img={result.children}
                  badge={result.children === "cart"}
                />
              </div>
            ))}
          {openLoginDialog && (
            <Login.Dialog
              resultPath={path}
              onClose={() => this.setState({ openLoginDialog: false })}
            />
          )}
        </div>
      </Style.LargeScreenWrapper>
    );
  }

  _needToLogin = data => {
    let { navActions, profile } = this.props;

    if (data.children === "profile" && !profile) {
      return this.setState({ openLoginDialog: true, path: "/me" });
    }

    if (data.children === "cart" && !profile) {
      return this.setState({ openLoginDialog: true, path: "/cart" });
    }

    return navActions.push(data.url);
  };

  _isActiveRoute = routeRegexp => {
    let { pathname } = this.props;

    if (routeRegexp === "/") {
      return ["/", "/tw", "/en"].some(p => p === pathname);
    }

    return !!pathname.match(routeRegexp);
  };
}

const Style = {
  Wrapper: styled.div`
    @media screen and (max-width: 800px) {
      padding: 10px 40px;
    }
    @media screen and (max-width: 414px) {
      padding: 10px 20px;
    }
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    padding: 10px 60px;
    height: ${height}px;
    z-index: 10;
    background-color: ${props =>
      props.isNavbarTransparent ? "transparent" : "white"};
    transition: background 200ms ease-in-out;
  `,

  Content: styled.div`
    margin: 0 auto;
    max-width: 1440px;
    height: 100%;
    display: flex;
    align-items: center;
    & .site-logo {
      cursor: pointer;

      :focus {
        outline: none;
      }
    }
  `,

  LargeScreenWrapper: styled.div`
    @media screen and (max-width: ${props => props.Breakpoint || 768}px) {
      display: none;
    }
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    & > .left {
      display: flex;
      align-items: center;
      padding-left: 50px;
      & > .nav-item {
        margin-right: 50px;
        padding-bottom: 4px;
        text-decoration: none;
        color: black;
        span {
          /* style refer: https://cssfx.dev/ underline１ */
          position: relative;
          font-size: 15px;
        }

        span::before {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 2px;
          background-color: #bd9f84;
          transform-origin: bottom right;
          transform: scaleX(0);
          transition: transform 0.5s ease;
        }

        span:hover::before {
          transform-origin: bottom left;
          transform: scaleX(1);
        }
      }
      & > .active {
        border-bottom: 1px solid #bd9f84;
      }
    }
    & > .right {
      display: flex;
      align-items: center;
      & > .nav-item {
        cursor: pointer;
        margin-right: 20px;
        text-decoration: none;
      }
    }
    & .nav-item :last-child {
      margin-right: 0px;
    }
  `,

  SmallScreenWrapper: styled.div`
    @media screen and (min-width: ${props => props.Breakpoint || 768}px) {
      display: none;
    }
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  `,

  SmallScreenMenu: styled.div`
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: ${props => (props.open ? "0" : "-100vw")};
    background-color: ${props =>
      props.open ? "rgba(218, 203, 189, 0.95)" : "rgba(0, 0, 0, 0)"};
    transition: background-color 250ms linear,
      left 0ms linear ${props => (props.open ? "0ms" : "250ms")};
    z-index: 5;
    & > .container {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 30px;
      & > .nav-item {
        color: ${textColor};
        height: 50px;
        text-decoration: none;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  `
};

export default connect(
  (state, ownProps) => ({
    profile: Selectors.getLoginUser(state),
    itemInCart: (() => {
      let total = 0;
      if (Selectors.getLocalCartData(state).items) {
        total = Selectors.getLocalCartData(state).items.length;
      }

      return total;
    })()
  }),
  ActionCreator
)(Navbar);
